<div  class="margin-top-bottom">
    <div>
        <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group" [ngModel]="classNumber">
            <mat-radio-button class="example-radio-button" [value]="1" [checked]="classNumber === 1" disabled>single</mat-radio-button>
            <mat-radio-button class="example-radio-button" [value]="2" [checked]="classNumber === 2" disabled>multiple</mat-radio-button>
        </mat-radio-group>
    </div>
    <div [ngSwitch]="classNumber">
        <div *ngSwitchCase="1" class="class-container">
            <div *ngFor="let floor of classAreas;let floorIndex = index" class="deck-container">
                <div *ngFor="let area of classAreas[floorIndex];let i = index" class="margin-top-bottom">
                    <h3>Deck {{floorIndex+1}}</h3>
                    <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group" [ngModel]="area.class">
                        <mat-radio-button class="example-radio-button" *ngFor="let class of serviceClasses" [value]="class.id" disabled>
                            {{class.name}}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </div>
        <div *ngSwitchCase="2" class="class-container">
            <div *ngFor="let floor of classAreas;let floorIndex = index" class="deck-container">
                <h3>Deck {{floorIndex+1}}</h3>
                <div *ngFor="let area of classAreas[floorIndex];let i = index" class="margin-top-bottom">
                    <div>
                        <mat-form-field appearance="outline" class="margin-left-right">
                            <mat-label>Start of area</mat-label>
                            <input matInput type="number" autoComplete="off" [ngModel]="i>0?  classAreas[floorIndex][i-1].endpoint : 0" disabled>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="margin-left-right">
                            <mat-label>End of area</mat-label>
                            <input matInput type="number" autoComplete="off" [ngModel]="area.endpoint" disabled>
                        </mat-form-field>
                    </div>
                    <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group" [ngModel]="area.class">
                        <mat-radio-button class="example-radio-button" *ngFor="let class of serviceClasses"
                            [value]="class.id" name="classCategory" [checked]="class.id === area.value" disabled>
                            {{class.name}}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </div>
    </div>
</div>